// API Configuration
export const url = 'https://admin.seekdeals.in';
// export const url = 'http://192.168.137.112:8000';
// export const url = 'http://localhost:8000';
//172.22.134.234:8000
//